module.exports = __webpack_public_path__ + "static/media/set1.7cce3992.png";